import { render } from "./SwiperComponent.vue?vue&type=template&id=67af347a"
import script from "./SwiperComponent.vue?vue&type=script&lang=js"
export * from "./SwiperComponent.vue?vue&type=script&lang=js"

import "./SwiperComponent.vue?vue&type=style&index=0&id=67af347a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__